import React, { useEffect } from "react";
import { Grid, IconButton, Box } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  fieldBox: {
    padding: theme.spacing(1.5), // uniform padding
    // marginBottom: theme.spacing(1),
    borderRadius: "12px", // smooth rounded corners
    backgroundColor: "#f9f9f9", // light subtle background
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)", // soft shadow for depth
    position: "relative",
    width: "100%",
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5),
    },
  },
  closeBtn: {
    position: "absolute",
    right: 10,
    top: "50%",
    padding: "8px",
    transform: "translateY(-50%)",
    color: "#666",
    "&:hover": {
      color: "#d32f2f",
    },
  },
  inputField: {
    width: "75%",
  },
}));


const FreqPowerCard = ({ bodies, setBodies, disabled = false, onRemove }) => {
  const classes = useStyles();

  const handleBodyChange = (index, field, value) => {
    setBodies(arr => arr.map((body, i) =>
      i === index
        ? {
            ...body,
            [field]:
              field === "rrpm_c"
                ? value === "" ? "" : parseInt(value, 10)
                : field === "power"
                  ? value === "" ? "" : parseFloat(value)
                  : value
          }
        : { ...body }
    ));
  };

  return (
    <>
      {bodies.map((body, index) => (
        <div className="py-15" key={index}>
          <Box className={classes.fieldBox}>
            {!disabled && (
              <IconButton
                size="small"
                className={classes.closeBtn}
                onClick={() => onRemove(index)}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            )}

            <Grid container alignItems="center" spacing={5}>
              <Grid item xs={4}>
                <label className="title">Frequency:</label>
                <input
                  className={`add-input xl`}
                  placeholder="Enter Frequency"
                  type="text"
                  value={body.frequency}
                  disabled={disabled}
                  onChange={(e) =>
                    handleBodyChange(index, "frequency", e.target.value)
                  }
                />
              </Grid>

              <Grid item xs={3}>
                <label className="title">rrpm_c:</label>
                <input
                  className={`add-input xl ${classes.inputField}`}
                  placeholder="Enter rrpm_c"
                  type="number"
                  value={body.rrpm_c}
                  disabled={disabled}
                  onChange={(e) =>
                    handleBodyChange(index, "rrpm_c", e.target.value)
                  }
                />
              </Grid>

              <Grid item xs={3}>
                <label className="title">Power:</label>
                <input
                  className={`add-input xl ${classes.inputField}`}
                  placeholder="Enter Power"
                  type="number"
                  value={body.power}
                  disabled={disabled}
                  onChange={(e) =>
                    handleBodyChange(index, "power", e.target.value)
                  }
                />
              </Grid>
            </Grid>
          </Box>
        </div>
      ))}
    </>
  );
};

export default FreqPowerCard;